import PropTypes from 'prop-types';
import React from 'react';

import { buildImagePath } from '../../JobComponents/Company/Image/logo';

import './StoryCard.scss';

export default class StoryCard extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * string of main image
         */
        image: PropTypes.string.isRequired,
        /**
         * svg of icon
         */
        icon: PropTypes.node.isRequired,
        /**
         * string of title
         */
        title: PropTypes.string.isRequired,
        /**
         * string of description
         */
        description: PropTypes.string.isRequired,
    };

    render() {
        const { image, icon, title, description } = this.props;
        return (
            <div className="component-Groups-StoryCard">
                <img
                    src={buildImagePath(image, 'default', { default: '' })}
                    alt="story-image"
                />
                <div className="content">
                    {icon}
                    <div className="text">
                        <h2>{title}</h2>
                        <p>{description}</p>
                    </div>
                </div>
            </div>
        );
    }
}
